import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0ab7532b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ab7532b')) {
      api.createRecord('0ab7532b', component.options)
    } else {
      api.reload('0ab7532b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0ab7532b", function () {
      api.rerender('0ab7532b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/role/index.vue"
export default component.exports